import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal } from '_zari/core'

import * as CentrosCostoService from 'services/centrosCosto.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from '../_shared/validation'

const NuevoCentroCostoModal = ({ handleClose, show, refreshTreeView, modalData, nivel }) => {
  const __zariContext = React.useContext(ZariContext)
  const formInitialValues = React.useMemo(
    () => ({
      anoMesFin: modalData.anoMesFin || '',
      nivel: nivel,
      descripcion: modalData.descripcion || '',
      tipo: modalData.tipo || '',
      codigo: modalData.codigo || '',
      clase9: modalData.clase9 || '',
      descripcionClase9: modalData.descripcionClase9 || ''
    }),
    [modalData, nivel]
  )

  const submitHandler = async data => {
    await CentrosCostoService.actualizarCentroCosto(modalData._id, data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha actualizado.')
        refreshTreeView()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>EDITAR CENTRO COSTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setValues }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CodigoFormGroup iValue={values.codigo} />
              <FormGroups.DescripcionFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
              {nivel === 1 && (
                <FormGroups.Clase9FormGroup
                  iDescripcionName='descripcionClase9'
                  iLabel='Clase 9'
                  iName='clase9'
                  iError={errors.clase9}
                  iTouched={touched.clase9}
                  iValue={values.clase9}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              )}
              {nivel === 2 && (
                <>
                  <FormGroups.TipoFormGroup iValue={values.tipo} fIsSubmitting={isSubmitting} />
                  <FormGroups.AnoMesFinFormGroup iError={errors.anoMesFin} iTouched={touched.anoMesFin} fIsSubmitting={isSubmitting} />
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Actualizar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoCentroCostoModal
